var TECL_TenderProductsSelection = {

    // Initialise the Tenders Products Selection page
    Initialise: function() {
        TECL_TenderGeneral.HidePleaseWaitDlg();

        // Select the first category by default
        var firstButton = $(".tenderProductCategoryButton").first();
        var categoryId = $(firstButton).attr("data-id");
        TECL_TenderProductsSelection.ChangeSelectedSection(categoryId);

        TECL_TenderGeneral.InitialiseAccordionControls();

        window.scrollTo(0, 0);

        TECL_TenderProductsSelection.UpdateProductListHeader();

        // Update the progress bar
        TECL_TenderGeneral.UpdateProgressBar(0);
        TECL_TenderGeneral.InitialiseStickySidebar();

        // Stop quantity fields having decimals, by stripping them off when the user leaves the field
        $(document).on("blur.Quantity", ".valQuantity", function() {
            var quantity = parseInt($(this).val());
            if (quantity < 0) {
                quantity = 0;
            }
            $(this).val(quantity);
        });

        TECL_TenderProductsSelection.FormatBudgetOnChange();
    },

    // Make sure there are only 2 decimal places and the number is a positive number
    FormatBudgetOnChange: function() {
        $(document).on("blur.Budget", ".valBudget", function() {
            var price = parseFloat($(this).val());
            var finalPrice = price.toFixed(2);

            if (finalPrice < 0) {
                finalPrice = 0;
            }
            $(this).val(finalPrice);
        });
    },

    // Select the first category button and section
    ChangeSelectedSection: function(categoryId) {
        $(".tenderProductCategoryButton")
            .each(function() {
                var catId = $(this).attr("data-id");
                if (catId === categoryId) {
                    $(this).addClass("selectedButton");
                } else {
                    $(this).removeClass("selectedButton");
                }
            });

        $(".tenderProductCategorySection")
            .each(function() {
                var catId = $(this).attr("data-id");
                if (catId === categoryId) {
                    $(this).removeClass("hidden");

                    // If there's only on sub category open it
                    var subCategories = $(this).find(".panel-collapse");
                    if (subCategories.length === 1) {
                        $(subCategories).collapse("show");
                    }

                } else {
                    $(this).addClass("hidden");
                }
            });
    },

    // Continue to the next stage
    ContinueToNextStage: function() {
        if (TECL_TenderProductsSelection.ValidatePage()) {
            var cacheId = $("#cacheId").val();
            var tenderName = $("#tenderName").val();

            if (TECL_Master.AddLock("ContinueNextStageQuoteDuration")) {
                TECL_TenderGeneral.DisplayPleaseWaitDlg();

                // Call Server to add the product request to the cache and reload the product request list
                $.ajax({
                    url: baseSiteUrl + "umbraco/Surface/Tender/ContinueNextStageQuoteDuration",
                    type: "POST",
                    data: {
                        cacheId: cacheId,
                        tenderName: tenderName
                    },
                    error: function(exc) {
                        TECL_Master.ClearLock("ContinueNextStageQuoteDuration");
                    },
                    success: function(partialViewHtml) {
                        TECL_Master.ClearLock("ContinueNextStageQuoteDuration");
                        if (partialViewHtml) {
                            $("#tenderPage").html(partialViewHtml);
                        }
                    }
                });
            }
        }
    },

    // Vaidate the page
    ValidatePage: function() {
        $("#errTenderName").addClass("hidden");
        $("#errProductRequests").addClass("hidden");

        var noErrors = true;

        var tenderName = $("#tenderName").val();
        if (!tenderName) {
            noErrors = false;
            $("#errTenderName").removeClass("hidden");
        }

        var childItems = $(".TenderProductRequestItems").children(".TenderProductRequestSubCategory");
        if (!childItems || childItems.length === 0) {
            noErrors = false;
            $("#errProductRequests").removeClass("hidden");
        }

        return noErrors;
    },

    // Handle the adding of a product request
    AddProductRequestToItemsList: function(parentControlId) {

        var parentDiv = $(parentControlId);
        parentDiv.find(".errProductId").addClass("hidden");
        parentDiv.find(".errQuantity").addClass("hidden");
        var dropdownListId = parentDiv.find("[name='ddlProductList']").attr("id");

        var cacheId = $("#cacheId").val();

        var quantityCntrl = parentDiv.find(".valQuantity");

        var isOtherItem;
        var valProductId;
        var valProductName;

        if (dropdownListId && dropdownListId.length > 0) {
            valProductId = $("#" + dropdownListId).val();
            valProductName = $("#" + dropdownListId).data("kendoDropDownList").text();
            isOtherItem = false;
        } else {
            valProductId = null;
            valProductName = "Other";
            isOtherItem = true;
        }

        var valBudget = parentDiv.find(".valBudget").val();
        var valNotes = parentDiv.find(".valNotes").val();
        var containerId = parentDiv.find(".valCategoryId").val();
        var tagId = parentDiv.find(".valSubCategoryId").val();
        var tagContainerMapId = parentDiv.find(".valTagContainerMapId").val();
        var categoryName = parentDiv.find(".valCategoryName").val();
        var subCategoryName = parentDiv.find(".valSubCategoryName").val();

        var tagName;
        if (isOtherItem === true) {
            tagName = categoryName + " - " + subCategoryName;
        } else {
            tagName = subCategoryName;
        }

        var valQuantity;
        if (quantityCntrl.length > 0) {
            valQuantity = $(quantityCntrl).val();
        } else {
            valQuantity = 1;
        }

        var noErrors = true;

        if (isOtherItem === false && !valProductId) {
            noErrors = false;
            parentDiv.find(".errProductId").removeClass("hidden");
        }

        if (!valQuantity || valQuantity <= 0) {
            noErrors = false;
            parentDiv.find(".errQuantity").removeClass("hidden");
        }

        if (noErrors) {
            TECL_TenderProductsSelection.DisplayItemAddedDlg(true);

            if (TECL_Master.AddLock("AddEditProductRequest")) {
                var productRequest = {
                    CacheId: cacheId,
                    ProductId: valProductId,
                    ProductName: valProductName,
                    Quantity: valQuantity,
                    Budget: valBudget,
                    Notes: valNotes,
                    ContainerId: containerId,
                    TagId: tagId,
                    TagName: tagName,
                    IsOtherItem: isOtherItem,
                    IsFreeTextItem: false,
                    TagContainerMapId: tagContainerMapId
                }

                TECL_TenderProductsSelection.AddEditProductRequest(productRequest, true, false);
            }
        }
    },

    // Handle the adding of a product request
    AddFreeTextItemToList: function() {
        $("#errFreeTextItemName").addClass("hidden");
        $("#errFreeTextItemQuantity").addClass("hidden");
        var cacheId = $("#cacheId").val();

        var valProductName = $("#valFreeTextItemName").val();
        var valBudget = $("#valFreeTextItemBudget").val();
        var valNotes = $("#valFreeTextItemNotes").val();

        var quantityCntrl = $("#valFreeTextItemQuantity");
        var valQuantity;
        if (quantityCntrl.length > 0) {
            valQuantity = $(quantityCntrl).val();
        } else {
            valQuantity = 1;
        }

        var noErrors = true;

        if (!valProductName || valProductName == "") {
            noErrors = false;
            $("#errFreeTextItemName").removeClass("hidden");
        }

        if (!valQuantity || valQuantity <= 0) {
            noErrors = false;
            $("#errFreeTextItemQuantity").removeClass("hidden");
        }

        if (noErrors) {
            TECL_TenderProductsSelection.DisplayItemAddedDlg(true);

            if (TECL_Master.AddLock("AddEditProductRequest")) {
                var productRequest = {
                    CacheId: cacheId,
                    ProductId: null,
                    ProductName: valProductName,
                    Quantity: valQuantity,
                    Budget: valBudget,
                    Notes: valNotes,
                    ContainerId: null,
                    TagId: null,
                    TagName: "Free Text Items",
                    IsOtherItem: false,
                    IsFreeTextItem: true,
                    TagContainerMapId: null
                }

                TECL_TenderProductsSelection.AddEditProductRequest(productRequest, true, true);
            }
        }
    },

    //  Populate and open the edit product request dialog
    OpenProductRequestEditDlg: function(parentControlId) {

        $("#editProductRequestDlgErrQuantity").addClass("hidden");

        var parentDiv = $("#" + parentControlId);
        var valProductId = parentDiv.find(".TenderProductRequestItemProductId").val();
        var valProductName = parentDiv.find(".TenderProductRequestItemProductName").val();
        var valQuantity = parentDiv.find(".TenderProductRequestItemQuantity").val();
        var valBudget = parentDiv.find(".TenderProductRequestItemBudget").val();
        var valNotes = parentDiv.find(".TenderProductRequestItemNotes").val();
        var valContainerId = parentDiv.find(".TenderProductRequestItemContainerId").val();
        var valTagId = parentDiv.find(".TenderProductRequestItemTagId").val();
        var valTagName = parentDiv.find(".TenderProductRequestItemTagName").val();
        var valTagContainerMapId = parentDiv.find(".TenderProductRequestItemTagContainerMapId").val();

        $("#editProductRequestDlgProductId").val(valProductId);
        $("#editProductRequestDlgProductName").text(valProductName);

        $("#editProductRequestDlgBudget").val(valBudget);
        $("#editProductRequestDlgNotes").val(valNotes);
        $("#editProductRequestDlgCategoryId").val(valContainerId);
        $("#editProductRequestDlgSubCategoryId").val(valTagId);
        $("#editProductRequestDlgSubCategoryName").val(valTagName);
        $("#editProductRequestDlgTagContainerMapId").val(valTagContainerMapId);

        var displayProductQuantity = $("#displayProductQuantityCntrl").val();

        if (valProductId && (displayProductQuantity === "true" || displayProductQuantity === "True")) {
            $(".editProductRequestDlgQuantitySection").removeClass("hidden");
            $("#editProductRequestDlgQuantity").val(valQuantity);
        } else {
            $(".editProductRequestDlgQuantitySection").addClass("hidden");
        }

        // Show the modal dialog but make it synchronous
        $("#tenderProductRequestEditDlg")
            .modal({
                backdrop: 'static',
                keyboard: false
            });
        $("#tenderProductRequestEditDlg").modal("show");
    },

    // Delete a product request
    DeleteProductRequest: function(parentControlId) {
        var parentDiv = $("#" + parentControlId);
        var productId = parentDiv.find(".TenderProductRequestItemProductId").val();
        var tagContainerMapId = parentDiv.find(".TenderProductRequestItemTagContainerMapId").val();
        var cacheId = $("#cacheId").val();

        if (TECL_Master.AddLock("DeleteProductRequest")) {
            // Call Server to add the product request to the cache and reload the product request list
            $.ajax({
                url: baseSiteUrl + "umbraco/Surface/Tender/DeleteProductRequest",
                type: "POST",
                data: {
                    cacheId: cacheId,
                    productId: productId,
                    tagContainerMapId: tagContainerMapId
                },
                error: function(exc) {
                    TECL_Master.ClearLock("DeleteProductRequest");
                },
                success: function(productRequestHtml) {
                    TECL_Master.ClearLock("DeleteProductRequest");
                    if (productRequestHtml) {
                        $("#ProductRequests").empty().html(productRequestHtml);
                    }

                    TECL_TenderProductsSelection.UpdateProductListHeader();
                }
            });
        }
    },

    // Save the updated data of a product request
    SaveEditedProductRequest: function() {

        $("#editProductRequestDlgErrQuantity").addClass("hidden");

        var noErrors = true;
        var cacheId = $("#cacheId").val();
        var valProductId = $("#editProductRequestDlgProductId").val();
        var valProductName = $("#editProductRequestDlgProductName").text();
        var valBudget = $("#editProductRequestDlgBudget").val();
        var valNotes = $("#editProductRequestDlgNotes").val();
        var containerId = $("#editProductRequestDlgCategoryId").val();
        var tagId = $("#editProductRequestDlgSubCategoryId").val();
        var tagName = $("#editProductRequestDlgSubCategoryName").val();
        var tagContainerMapId = $("#editProductRequestDlgTagContainerMapId").val();

        var valQuantity;
        if ($(".editProductRequestDlgQuantitySection").hasClass("hidden")) {
            valQuantity = 1;
        } else {
            valQuantity = $("#editProductRequestDlgQuantity").val();
        }

        if (valQuantity <= 0) {
            noErrors = false;
            $("#editProductRequestDlgErrQuantity").removeClass("hidden");
        }

        if (noErrors) {
            var productRequest = {
                CacheId: cacheId,
                ProductId: valProductId,
                ProductName: valProductName,
                Quantity: valQuantity,
                Budget: valBudget,
                Notes: valNotes,
                ContainerId: containerId,
                TagId: tagId,
                TagName: tagName,
                TagContainerMapId: tagContainerMapId
            }

            TECL_TenderProductsSelection.AddEditProductRequest(productRequest, false, false);
        }
    },

    // Add edit the save model
    AddEditProductRequest: function(saveModel, itemAddedDlgDisplayed, clearFreeText) {

        // Call Server to add the product request to the cache and reload the product request list
        $.ajax({
            url: baseSiteUrl + "umbraco/Surface/Tender/AddEditProductRequest",
            type: "POST",
            data: {
                saveModel: saveModel
            },
            error: function(exc) {
                TECL_Master.ClearLock("AddEditProductRequest");
                $("#tenderProductRequestEditDlg").modal("hide");
            },
            success: function(productRequestHtml) {
                TECL_Master.ClearLock("AddEditProductRequest");

                if (productRequestHtml) {
                    $("#errProductRequests").addClass("hidden");

                    $("#ProductRequests").empty().html(productRequestHtml);
                }

                TECL_TenderProductsSelection.UpdateProductListHeader();

                $("#tenderProductRequestEditDlg").modal("hide");

                if (itemAddedDlgDisplayed) {
                    TECL_TenderProductsSelection.DisplayItemAddedDlg(false);
                }

                if (clearFreeText) {
                    $("#valFreeTextItemName").val("");
                    $("#valFreeTextItemQuantity").val("1");
                    $("#valFreeTextItemBudget").val("0.00");
                    $("#valFreeTextItemNotes").val("");
                }
            }
        });
    },

    // Update the product list section
    UpdateProductListHeader: function() {
        var productRequestItems = $("#ProductRequests").find(".TenderProductRequestItem");

        if (productRequestItems.length > 0) {
            $("#productListEmptyText").addClass("hidden");
        } else {
            $("#productListEmptyText").removeClass("hidden");
        }
    },

    // Display item added dlg for a set amount of time
    DisplayItemAddedDlg: function(show) {
        if (show) {
            $("#itemAddedDialog").modal("show");
        } else {
            function HideItemAddedDlg() {
                $("#itemAddedDialog").modal("hide");
            }

            // Wait a set amount of time till the dialog is closed
            setTimeout(HideItemAddedDlg, 1000);
        }
    }
};